/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import apiClient from '../api/client';

export const serviceRequestTypeService = {
  // GET /api/service-request-types
  getServiceRequestTypes: (params = {}) => apiClient.get('/service-request-types', { params }),

  // GET /api/service-request-types/:uid
  getServiceRequestTypeById: (uid) => apiClient.get(`/service-request-types/${uid}`),

  // POST /api/service-request-types
  createServiceRequestType: (payload) => apiClient.post('/service-request-types', payload),

  // PATCH /api/service-request-types/:uid
  updateServiceRequestType: (uid, payload) => apiClient.patch(`/service-request-types/${uid}`, payload),

  // DELETE /api/service-request-types/:uid
  deleteServiceRequestType: (uid) => apiClient.delete(`/service-request-types/${uid}`),

  // Hierarchy Tree APIs
  // GET /api/service-request-types/:uid/hierarchy
  getHierarchy: (uid, params = {}) => apiClient.get(`/service-request-types/${uid}/hierarchy`, { params }),

  // PUT /api/service-request-types/:uid/hierarchy/levels
  setHierarchyLevels: (uid, levels) => apiClient.put(`/service-request-types/${uid}/hierarchy/levels`, { levels }),

  // POST /api/service-request-types/:uid/hierarchy/nodes
  createTreeNode: (uid, payload) => apiClient.post(`/service-request-types/${uid}/hierarchy/nodes`, payload),

  // PATCH /api/service-request-types/:uid/hierarchy/nodes/:nodeUid
  updateTreeNode: (uid, nodeUid, payload) => apiClient.patch(`/service-request-types/${uid}/hierarchy/nodes/${nodeUid}`, payload),

  // DELETE /api/service-request-types/:uid/hierarchy/nodes/:nodeUid
  deleteTreeNode: (uid, nodeUid) => apiClient.delete(`/service-request-types/${uid}/hierarchy/nodes/${nodeUid}`),
};

